@file:Suppress("EXPECT_ACTUAL_CLASSIFIERS_ARE_IN_BETA_WARNING")

package com.schoolconnect.app.util

import kotlinx.browser.window

actual object BuildConfig {
    actual fun isDebug(): Boolean = AppInfo.isDebug
    actual fun isServerApp(): Boolean = false
    actual fun platform(): PlatformType = PlatformType.JS
    actual fun getVersion(): String = AppInfo.versionName
    actual fun userAgent(): PlatformType = detectUserAgent()
}

private fun detectUserAgent(): PlatformType {
    val ua = runCatching { window.navigator.userAgent.lowercase() }.getOrDefault("")
    return when {
        "android" in ua -> PlatformType.ANDROID
        "iphone" in ua || "ipad" in ua || "ipod" in ua -> PlatformType.IOS
        else -> PlatformType.DESKTOP
    }
}
